import axiosClient from "./axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";
const fileManagerApi = {
  getFiles: (params) => {
    const url = "file/get-files";
    //return axiosClient.post(url + "?folderPath=" + params.folderPath);

    return axiosClient.get(url, { params: params });
  },
  getFilesV2: (params) => {
    const url = "file/get-files-2";
    //return axiosClient.post(url + "?folderPath=" + params.folderPath);

    return axiosClient.get(url, { params: params });
  },
  uploadFiles: (payload) => {
    const url = "file/upload";
    return axiosClient.post(url, payload);
  },
  removeFiles: (payload) => {
    const url = "file/delete-files";
    return axiosClient.delete(url, { params: payload });
  },

  renameFiles: (payload) => {
    const url = "file/rename-file";
    return axiosClient.post(url, payload);
  },

  renameFolder: (payload) => {
    const url = "file/rename-folder";
    return axiosClient.post(url, payload);
  },

  removeFolder: (payload) => {
    const url = "file/delete-folder";
    return axiosClient.delete(url, { params: payload });
  },
};

export default fileManagerApi;
